import { isAbortError } from '@app/errors/AbortError'

import { captureException } from '@app/utils/errorReport/errorReport'
import { sleep } from '@app/utils/sleep'

import { withAbortSignal } from '@app/packages/abortContext/actions'
import { spawn } from '@app/packages/disposable/spawn'
import { getBuildInfo } from '@app/packages/internalApi/actions/build_info'
import { ReactiveValue } from '@app/packages/reactives/ReactiveValue'

import { callInternalApi } from '@app/store/actions/api'
import type { Store } from '@app/store/store'

export class BuildTracker {
  readonly sha = new ReactiveValue<string | null>(null)
  private stack = new DisposableStack()
  abortController: AbortController | null = null

  constructor(store: Store, intervalMs: number) {
    this.stack.use(this.start(store, intervalMs))
  }

  [Symbol.dispose]() {
    if (!this.stack.disposed) this.stack.dispose()
  }

  private start(
    store: Store,
    /** Interval in ms */
    updateInterval: number
  ) {
    return spawn(async stack => {
      const ab = stack.adopt(new AbortController(), c => c.abort())

      while (true) {
        if (ab.signal.aborted) break
        try {
          const resp = await store.dispatch(withAbortSignal(ab.signal, callInternalApi(getBuildInfo())))
          this.sha.update(() => resp.data.attributes.sha)
        } catch (e) {
          if (!isAbortError(e)) {
            captureException(e, { tags: { service: 'BuildTracker' } })
          }
        }
        if (ab.signal.aborted) break
        await sleep(updateInterval)
      }
    })
  }
}
